import { createStyles, makeStyles } from '@material-ui/core/styles';

// eslint-disable-next-line no-unused-vars
const useStyles = (borderRadius, startColor, middleFirstColor, middleSecondColor, finishColor) =>
  makeStyles(() =>
    createStyles({
      loadingOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: `linear-gradient(90deg, ${startColor}, ${middleFirstColor},${
          middleSecondColor ? middleSecondColor + ', ' : ''
        } ${finishColor})`,
        backgroundSize: '200% 200%',
        animation: '$gradient 3s ease-in-out infinite',
        animationDirection: 'alternate',
        opacity: '.2',
        borderRadius: borderRadius,
      },
      '@keyframes gradient': {
        '0%': {
          backgroundSize: '1000% 200%',
          backgroundPosition: '0% 0%',
        },
        '100%': {
          backgroundSize: '200% 200%',
          backgroundPosition: '100% 0%',
        },
      },
    }),
  );

export default useStyles;
